'use strict';

/**
 * @classname ArchiveExpansion
 * @classdesc SP ギャラリー画像の長押し拡大
 */
export default class ArchiveExpansion {
	/**
	 * @constructor
	 * @param {jQuery} $e - .block--gallery-grid
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$grid = $e;
		this._$items = this._$grid.find('.block--gallery-item');
		this._holdMs = 300;
		this._timer = null;

		this._$items.on('touchstart', (e) => this.onTouchStart(e));
		this._$items.on('touchend touchmove touchcancel', (e) => this.onTouchEnd(e));
	};

	/**
	 * 長押し開始（タイマーが完了したら拡大表示）
	 *
	 * @memberof ArchiveExpansion
	 * @return undefined
	 */
	onTouchStart(e) {
		const $item = $(e.currentTarget);
		clearTimeout(this._timer);
		this._timer = setTimeout(() => {
			this._$items.not($item).removeClass('is-zoomed');
			$item.addClass('is-zoomed');
		}, this._holdMs);
	}

	/**
	 * 長押し終了・キャンセル（拡大表示を解除）
	 *
	 * @memberof ArchiveExpansion
	 * @return undefined
	 */
	onTouchEnd(e) {
		clearTimeout(this._timer);
		$(e.currentTarget).removeClass('is-zoomed');
	}
};
